/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {useAuth} from "../auth";
import {SelectDealer} from "./components/SelectDealer";
import {SelectApplication} from "./components/SelectApplication";
import {SelectLanguage} from "./components/SelectLanguage";

const Layout = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'none'
        return () => {
        }
    }, [])

    return (
        <div
            className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        >
            {/* begin::Content */}
            <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
                {/* begin::Wrapper */}
                <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>
                    <Outlet/>
                </div>
                {/* end::Wrapper */}
            </div>
            {/* end::Content */}
        </div>
    )
}

const SettingsSelectionPage = () => {
    const {currentUser} = useAuth()

    const languageSelected = currentUser?.language != null
    const dealerSelected = currentUser?.dealer_id != null
    const applicationSelected = currentUser?.application_id != null

    const page = () => {
        if (!languageSelected) {
            return <SelectLanguage/>
        }
        if (!dealerSelected) {
            return <SelectDealer/>
        }
        if (!applicationSelected) {
            return <SelectApplication/>
        }
        return <span>Unknown route</span>
    }

    return (
        <Routes>
            <Route element={<Layout/>}>
                <Route path='*' element={page()}/>
            </Route>
        </Routes>
    )
}

export {SettingsSelectionPage}
